import { render, staticRenderFns } from "./TabelaNotas.vue?vue&type=template&id=25b90fda&"
import script from "./TabelaNotas.vue?vue&type=script&lang=js&"
export * from "./TabelaNotas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports